import React from "react"
import { useNavigate } from "react-router"

import DeviceChips, {
  MacOSChip,
  WindowsChip,
} from "@podcastsoundboard/ps-lib/components/DeviceChips/DeviceChips"
import FullPageContentContainer from "../../../../../../components/FullPageContentContainer"
import { useAppSelector } from "../../../../../../redux"
import {
  Box,
  Chip,
  Paper,
  Stack,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@podcastsoundboard/ps-lib/ui"
import PublicIcon from "@podcastsoundboard/ps-lib/ui/icons/Public"

const DesktopContent: React.FC = () => {
  const navigate = useNavigate()
  const currentUserProfile = useAppSelector((state) => state.currentUserProfile)
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)

  const isSmallScreen = useMediaQuery("(max-width: 640px)")

  return (
    <Box className="hero hero-bg-3 pb-20">
      <Toolbar />

      <FullPageContentContainer minHeight="auto" maxWidth="xl">
        <DeviceChips
          handleOpenUrl={(url) => window.open(url, "_blank")}
          navigate={navigate}
        />

        <Stack
          direction="row"
          gap="1rem"
          alignItems="center"
          flexWrap={isSmallScreen ? "wrap" : "nowrap"}
          justifyContent="center"
        >
          <Paper className="p-8 rounded-[20px]">
            <Stack
              direction="column"
              spacing={3}
              justifyContent="center"
              alignItems="flex-start"
            >
              <Typography
                variant="body1"
                align="left"
                color="text.secondary"
                fontWeight={800}
                className="pt-4 mb-2"
              >
                Desktop App
              </Typography>
              <Typography
                component="h2"
                variant="h3"
                align="left"
                color="text.primary"
                className="mt-0 pb-4"
              >
                Podcast Soundboard for MacOS & Windows
              </Typography>
            </Stack>

            <Typography
              variant="body1"
              align="left"
              color="text.primary"
              className="pb-8 mt-8"
              fontSize={"1.2rem"}
            >
              Podcast Soundboard for Desktop is the perfect soundbite and track
              playing tool for those who need something offline.
            </Typography>

            <Stack direction="row" gap="0.5rem" flexWrap="wrap">
              <WindowsChip
                handleOpenUrl={(url) => window.open(url, "_blank")}
                width="auto"
                size="small"
              />
              <MacOSChip
                handleOpenUrl={(url) => window.open(url, "_blank")}
                backgroundColor="white"
                overrideColor="black"
                width="auto"
                size="small"
              />
              <Chip
                size="medium"
                clickable
                color="info"
                onClick={() => navigate("/app/windows#downloads")}
                label="Downloads"
              />
              <Chip
                size="medium"
                clickable
                color="info"
                onClick={() =>
                  currentUserProfile
                    ? navigate("/app/account/subscription")
                    : navigate("/app/signup")
                }
                label="Web"
                icon={<PublicIcon />}
              />

              <Chip
                size="medium"
                clickable
                onClick={() => navigate("/app/windows/changelog")}
                label="Changelog"
              />
            </Stack>
          </Paper>

          <Box className="p-4">
            <img
              style={{
                maxHeight: "40vh",
                maxWidth: isSmallScreen ? "80vw" : "40vw",
              }}
              src={
                darkModeEnabled
                  ? "/img/devices/laptop-dark.png"
                  : "/img/devices/laptop-light.png"
              }
              alt={
                darkModeEnabled ? "Dark mode on mobile" : "Light mode on mobile"
              }
            />
          </Box>
        </Stack>
      </FullPageContentContainer>
    </Box>
  )
}

export default DesktopContent
